export default __webpack_public_path__ + "static/media/725.f961a841.gif";